export class XmlRuleElement {
  public tagName: string;
  public empty: boolean;
  public floating: boolean;

  public static Sorted(elements: XmlRuleElement[]): XmlRuleElement[] {
    const result = elements.sort((e1, e2) => {
      if (e1.tagName > e2.tagName) {
        return 1;
      }
      if (e1.tagName < e2.tagName) {
        return -1;
      }
      return 0;
    });
    return result;
  }

  public constructor(init?: Partial<XmlRuleElement>) {
    Object.assign(this, init);
  }
}
